document.addEventListener('DOMContentLoaded', function () {
  getHeaderHeight();
});
function getHeaderHeight() {
  const header = document.querySelector('.section-header');
  if (!header) return; // safety check
  const headerHeight = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height-new', `${headerHeight}px`);
}
window.addEventListener('resize', getHeaderHeight);
// announcement bar
document.addEventListener('DOMContentLoaded', function () {
  getAbarHeight();
});
function getAbarHeight() {
  const abar = document.querySelector('.announcement-bar-section');
  if (!abar) return; // safety check
  const abarHeight = abar.offsetHeight;
  document.documentElement.style.setProperty('--abar-height-new', `${abarHeight}px`);
}
window.addEventListener('resize', getAbarHeight);
